import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Row, Col } from "shards-react";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import { TabsLogisticsSub } from "shared/components";

import imgbox from "../../assets/img/imgbox.png";
import BackgroupImage from "../../assets/img/backgroup.png";
import { useTranslation } from "react-i18next";
const axios = require("axios").default;

const Nav = styled.div``;
const NavTab = styled.div`
  display: flex;
  margin-top: 10px;
  // justify-content: space-between;
  cursor: pointer;
  font-size: 16px;
  color: #000;
  flex-wrap: nowrap;
  overflow: auto;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .active {
    max-width: 238px;
    min-width: 238px;
    height: 279px;
    border-radius: 8px;
    border: none;
    background-color: #fff;
    .title-content {
      font-weight: bold;
    }
  }
`;
const NavContent = styled.div`
  background-image: url(${BackgroupImage});
`;
const NavItem = styled.div`
  overflow: hidden;
  text-align: center;
  flex-grow: 1;
  max-width: 220px;
  min-width: 220px;
  border-radius: 8px;
  position: relative;
  height: 257px;
  margin: 15px;
  // height: 234px;
  :hover {
    .img-content {
      transform: scale(1.3, 1.3);
    }
    .title-content {
      font-weight: bold;
    }
  }
`;
const TabTitle = styled.div`
  padding: 5px;
  position: absolute;
  bottom: 10px;
  width: 100%;
  color: #fff;
`;
const Image = styled.img`
  vertical-align: middle;
  border-style: none;
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  object-fit: cover;
  border-radius: 8px;
`;
const TabImage = styled.div`
  
  background-image: url('${(props) => (props.image ? props.image : imgbox)}');
  background-size: cover;
  display: block;
  height: 100%;
  transform: scale(1, 1);
  transition: transform 0.4s;
  border-radius: 8px;
`;
const BgColor = styled.div`
  background: linear-gradient(
    0deg,
    rgb(0 25 61) 25%,
    rgb(255 255 255 / 0%) 100%
  );
  height: 100%;
  opacity: 1.5;
  border-radius: 8px;
`;

const NavHeader = styled.div`
  background: linear-gradient(
    0deg,
    rgba(45, 117, 193, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  padding: 30px 0px 50px 0;
`;

const TabsLogistics = (props) => {
  const [dataTabList, setDataTabList] = useState(null);
  const [contentSettingId, setContentSettingId] = useState(1);
  const { t, i18n } = useTranslation();

  const selectTabs = (id) => {
    setContentSettingId(id);
  };
  useEffect(() => {
    var data = JSON.stringify({
      params: {
        contentSettingId: "",
      },
      show: 100,
      page: 1,
      orderBy: "contentSettingId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/contentlistshow`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        setDataTabList(response.data);
        // setTotalPage(response.data.totalPage);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [contentSettingId]);

  return (
    <NavContent>
      {/* <Container> */}
      <NavHeader>
        {/* <Container> */}
        <Row>
          <Col className="text-center">
            <h5 className="bold text-balck">
              - {t("common:homePage.InformaationList")} -
            </h5>
          </Col>
        </Row>
        <Nav tabs>
          <NavTab>
            {dataTabList != null &&
              dataTabList.data.length > 0 &&
              dataTabList.data.map((item, key) => {
                const split = item.contentSettingPic.split("\\");
                const path = `${baseUrl}/${split[0]}/${split[1]}`;
                return (
                  <NavItem
                    key={key}
                    className={
                      contentSettingId === item.contentSettingId ? "active" : ""
                    }
                    onClick={() => selectTabs(item.contentSettingId)}
                  >
                    <TabImage className="img-content" image={path}>
                      <BgColor></BgColor>
                    </TabImage>
                    <TabTitle className="title-content">
                      {i18n.language === "th"
                        ? item.contentSettingName
                        : item.contentSettingNameEN}
                    </TabTitle>
                  </NavItem>
                );
              })}
          </NavTab>
        </Nav>
        {/* </Container> */}
      </NavHeader>

      <TabsLogisticsSub contentId={contentSettingId} />
      {/* </Container> */}
    </NavContent>
  );
};
export default TabsLogistics;
